export const releaseNotes10 = '# Release notes - FlexCharge - Version MP\\_ 0.10.0\n' +
	'\n' +
	'### Bug\n' +
	'\n' +
	'[FC-1535](https://flex-charge.atlassian.net/browse/FC-1535) Merchants > Not SUPER\\_ADMIN get 401 error for merchants list\n' +
	'\n' +
	'### Task\n' +
	'\n' +
	'[FC-1551](https://flex-charge.atlassian.net/browse/FC-1551) Portal > Activity UI > Make Activity section use all available height \\+ add scrollers to Timeline and Additional information\n' +
	'\n' +
	'[FC-1550](https://flex-charge.atlassian.net/browse/FC-1550) Portal > Order > Activity log > No preview \\(activity information\\)\n' +
	'\n' +
	'[FC-1540](https://flex-charge.atlassian.net/browse/FC-1540) Add support for both server side error responses with response.data.errors and  only response.errors\n' +
	'\n' +
	'[FC-1534](https://flex-charge.atlassian.net/browse/FC-1534) Add timeout for popup messages\n' +
	'\n' +
	'[FC-1529](https://flex-charge.atlassian.net/browse/FC-1529) Merchants > Fees history table\n' +
	'\n' +
	'[FC-1525](https://flex-charge.atlassian.net/browse/FC-1525) Portal > Order view > Timeline view' +
	'\n' +
	'# Release notes - FlexCharge - Version MP\\_0.9.0\n' +
	'\n' +
	'### Bug\n' +
	'\n' +
	'[FC-1519](https://flex-charge.atlassian.net/browse/FC-1519) Refund 2 buttons > icons in button on button hover are not white\n' +
	'\n' +
	'[FC-1518](https://flex-charge.atlassian.net/browse/FC-1518) Date-picker OK button issue\n' +
	'\n' +
	'[FC-1516](https://flex-charge.atlassian.net/browse/FC-1516) Orders pagination\n' +
	'\n' +
	'[FC-1495](https://flex-charge.atlassian.net/browse/FC-1495) Portal > Wrong button text\n' +
	'\n' +
	'[FC-1492](https://flex-charge.atlassian.net/browse/FC-1492) Add tokenization information\n' +
	'\n' +
	'[FC-1484](https://flex-charge.atlassian.net/browse/FC-1484) Portal > Fix critical errors if server returns 500 \\(or other\\) error\n' +
	'\n' +
	'[FC-1478](https://flex-charge.atlassian.net/browse/FC-1478) Merchant > Fees history > after modification fees not added to history \\(without refresh\\)\n' +
	'\n' +
	'[FC-1477](https://flex-charge.atlassian.net/browse/FC-1477) Merchants > Save not working after deactivated merchants\n' +
	'\n' +
	'[FC-1476](https://flex-charge.atlassian.net/browse/FC-1476) Merchants > Sort not saved\n' +
	'\n' +
	'### Task\n' +
	'\n' +
	'[FC-1496](https://flex-charge.atlassian.net/browse/FC-1496) Merchant portal > Menu > Add reports section\n' +
	'\n' +
	'[FC-1479](https://flex-charge.atlassian.net/browse/FC-1479) Applicant > Rename button "Save and Send" to "Send"\n' +
	'\n' +
	'[FC-1474](https://flex-charge.atlassian.net/browse/FC-1474) Portal > Add Notifications page'+
	'\n' +
	'# Release notes - FlexCharge - Version MP\\_0.8.0\n' +
	'\n' +
	'### Bug\n' +
	'\n' +
	'[FC-1445](https://flex-charge.atlassian.net/browse/FC-1445) Portal > Merchants, Applications > Pagination is reset after viewing Merchant/Applicant information\n' +
	'\n' +
	'[FC-1436](https://flex-charge.atlassian.net/browse/FC-1436) Portal > Applicants > Bank account number validation is not shown\n' +
	'\n' +
	'[FC-1423](https://flex-charge.atlassian.net/browse/FC-1423) Merchants > Merchant configuration saved incorrectly\n' +
	'\n' +
	'### Task\n' +
	'\n' +
	'[FC-1483](https://flex-charge.atlassian.net/browse/FC-1483) Merchant > Refactoring according to PR\n' +
	'\n' +
	'[FC-1475](https://flex-charge.atlassian.net/browse/FC-1475) Rename Payment payouts to Payouts\n' +
	'\n' +
	'[FC-1472](https://flex-charge.atlassian.net/browse/FC-1472) Payment simulator server > Call transmit on 100 \\(success\\) response code from NMI\n' +
	'\n' +
	'[FC-1464](https://flex-charge.atlassian.net/browse/FC-1464) Portal > Merchant configuration > Add Locked and Payouts Enabled switches\n' +
	'\n' +
	'[FC-1455](https://flex-charge.atlassian.net/browse/FC-1455) Merchants > UX for tabs if input fields errors appear\n' +
	'\n' +
	'[FC-1451](https://flex-charge.atlassian.net/browse/FC-1451) Portal > Create Pending payouts page\n' +
	'\n' +
	'[FC-1450](https://flex-charge.atlassian.net/browse/FC-1450) Portal > Create UI for Merchant Fees History\n' +
	'\n' +
	'[FC-1447](https://flex-charge.atlassian.net/browse/FC-1447) Portal > Improve NewApplication component\n' +
	'\n' +
	'[FC-1446](https://flex-charge.atlassian.net/browse/FC-1446) Portal > Separate FormInput to different components\n' +
	'\n' +
	'[FC-1432](https://flex-charge.atlassian.net/browse/FC-1432) Merchants > Show content on different tabs pages instead of blocks with arrow\n' +
	'\n' +
	'[FC-1431](https://flex-charge.atlassian.net/browse/FC-1431) Portal > Setup Cypress and add a few initial tests\n' +
	'\n' +
	'[FC-1410](https://flex-charge.atlassian.net/browse/FC-1410) Merchant portal > Offers configuration section\n' +
	'\n' +
	'[FC-1137](https://flex-charge.atlassian.net/browse/FC-1137) Eligibility > Add UI on Portal to activate Experian real production calls for a merchant' +
	'\n' +
	'# Release notes - FlexCharge - Version MP\\_0.7.0\n' +
	'\n' +
	'### Bug\n' +
	'\n' +
	'[FC-1389](https://flex-charge.atlassian.net/browse/FC-1389) ConfirmApplication > Labels translations are not loaded, keys are shown\n' +
	'\n' +
	'[FC-1344](https://flex-charge.atlassian.net/browse/FC-1344) Merchant API > Partner ID is not saved or not returned from API\n' +
	'\n' +
	'[FC-1337](https://flex-charge.atlassian.net/browse/FC-1337) Portal API > Add merchant ID to Orders response\n' +
	'\n' +
	'[FC-1043](https://flex-charge.atlassian.net/browse/FC-1043) Edit Merchant > Fees section > Send Fees items IDs\n' +
	'\n' +
	'### Task\n' +
	'\n' +
	'[FC-1372](https://flex-charge.atlassian.net/browse/FC-1372) Orders > Add all possible Orders statuses list\n' +
	'\n' +
	'[FC-1369](https://flex-charge.atlassian.net/browse/FC-1369) Portal > Menu switch items\n' +
	'\n' +
	'[FC-1338](https://flex-charge.atlassian.net/browse/FC-1338) Portal > Orders > Make Merchant Name clickable \\+ Add view button\n' +
	'\n' +
	'[FC-1334](https://flex-charge.atlassian.net/browse/FC-1334) Review Applicant > Chargeback tooltip text\n' +
	'\n' +
	'[FC-1320](https://flex-charge.atlassian.net/browse/FC-1320) Order page > Remove items section for Partner\n' +
	'\n' +
	'[FC-1318](https://flex-charge.atlassian.net/browse/FC-1318) Portal > Remove logs for production build\n' +
	'\n' +
	'[FC-1305](https://flex-charge.atlassian.net/browse/FC-1305) Partner role > Orders page > Click on Merchant name should open Merchant by ID'+
	'\n' +
	'# Release notes - FlexCharge - Version MP\\_0.6.0\n' +
	'\n' +
	'### Bug\n' +
	'\n' +
	'[FC-1340](https://flex-charge.atlassian.net/browse/FC-1340) Partner modal > Change texts\n' +
	'\n' +
	'[FC-1339](https://flex-charge.atlassian.net/browse/FC-1339) Partner modal > Remove close on backdrop click\n' +
	'\n' +
	'[FC-1336](https://flex-charge.atlassian.net/browse/FC-1336) Partner > Edit > Email should be disabled / read-only\n' +
	'\n' +
	'[FC-1324](https://flex-charge.atlassian.net/browse/FC-1324) Portal menu > Fix icons styles\n' +
	'\n' +
	'[FC-1323](https://flex-charge.atlassian.net/browse/FC-1323) Application page > Fix Actions button styles\n' +
	'\n' +
	'[FC-1254](https://flex-charge.atlassian.net/browse/FC-1254) UI widget > Radius Slider design issue\n' +
	'\n' +
	'[FC-1207](https://flex-charge.atlassian.net/browse/FC-1207) UI GUI > Visual size of URL in website field in out of shape\n' +
	'\n' +
	'[FC-1201](https://flex-charge.atlassian.net/browse/FC-1201) Portal > Add validation to phone field\n' +
	'\n' +
	'[FC-1200](https://flex-charge.atlassian.net/browse/FC-1200) Portal > Application > Account and Routing numbers must be strings, not numbers\n' +
	'\n' +
	'### Task\n' +
	'\n' +
	'[FC-1321](https://flex-charge.atlassian.net/browse/FC-1321) Application > Create Partner button should open correct modal window\n' +
	'\n' +
	'[FC-1307](https://flex-charge.atlassian.net/browse/FC-1307) Partner role > Orders page > Remove click on all item row, only click on Order ID should open Order page by ID\n' +
	'\n' +
	'[FC-1291](https://flex-charge.atlassian.net/browse/FC-1291) Partners > Handle /invite response - show toast\n' +
	'\n' +
	'[FC-1289](https://flex-charge.atlassian.net/browse/FC-1289) Partners > Add invite button\n' +
	'\n' +
	'[FC-1271](https://flex-charge.atlassian.net/browse/FC-1271) Partners > Show Partner creation result popup\n' +
	'\n' +
	'[FC-1267](https://flex-charge.atlassian.net/browse/FC-1267) Partners > Show table with Partners list\n' +
	'\n' +
	'[FC-1266](https://flex-charge.atlassian.net/browse/FC-1266) Partners > Show new Partner modal window\n' +
	'\n' +
	'[FC-1257](https://flex-charge.atlassian.net/browse/FC-1257) Merchant portal > Backoffice > Partners section\n' +
	'\n' +
	'[FC-1251](https://flex-charge.atlassian.net/browse/FC-1251) Portal > Hide Developers menu section for Super Admin users\n' +
	'\n' +
	'[FC-1247](https://flex-charge.atlassian.net/browse/FC-1247) Merchant portal > Widget preview > Add tooltips for links\n' +
	'\n' +
	'[FC-1220](https://flex-charge.atlassian.net/browse/FC-1220) UI widget > Failed to cure message'+
	'\n' +
	'# Release notes - FlexCharge - Version MP\\_0.5.0\n' +
	'\n' +
	'### Bug\n' +
	'\n' +
	'[FC-1253](https://flex-charge.atlassian.net/browse/FC-1253) Applicant > Action button > design glitch\n' +
	'\n' +
	'[FC-1244](https://flex-charge.atlassian.net/browse/FC-1244) Merchant portal > Widget preview > Align vertically 3 icons for image\n' +
	'\n' +
	'[FC-1243](https://flex-charge.atlassian.net/browse/FC-1243) Merchant portal > Widget preview > Handle null values\n' +
	'\n' +
	'### Task\n' +
	'\n' +
	'[FC-1250](https://flex-charge.atlassian.net/browse/FC-1250) Login page > Add margin for version number\n' +
	'\n' +
	'[FC-1249](https://flex-charge.atlassian.net/browse/FC-1249) Merchant portal > Widget preview > Change text\n' +
	'\n' +
	'[FC-1248](https://flex-charge.atlassian.net/browse/FC-1248) Merchant portal > Widget preview > Remove colors block from color picker\n' +
	'\n' +
	'[FC-1234](https://flex-charge.atlassian.net/browse/FC-1234) Merchant portal > Widget preview > Add add 3 inputs for links - cancel / success / reject\n' +
	'\n' +
	'[FC-1233](https://flex-charge.atlassian.net/browse/FC-1233) Merchant portal > Widget preview > Add configuration for button and widget corners radius\n' +
	'\n' +
	'[FC-1232](https://flex-charge.atlassian.net/browse/FC-1232) Merchant portal > Widget preview > Show box shadow instead of border\n' +
	'\n' +
	'[FC-1231](https://flex-charge.atlassian.net/browse/FC-1231) Merchant portal > Widget preview > Change button text automatically according to button background\n' +
	'\n' +
	'[FC-1221](https://flex-charge.atlassian.net/browse/FC-1221) Merchant portal > Users > User initial background \\+ random colors\n' +
	'\n' +
	'[FC-1219](https://flex-charge.atlassian.net/browse/FC-1219) Merchant portal > Widget preview > Add image cropper\n' +
	'\n' +
	'[FC-1218](https://flex-charge.atlassian.net/browse/FC-1218) Merchant portal > Widget configuration page\n' +
	'\n' +
	'[FC-1203](https://flex-charge.atlassian.net/browse/FC-1203) Merchant portal > Forgot password page > design mismatch\n' +
	'\n' +
	'[FC-1202](https://flex-charge.atlassian.net/browse/FC-1202) Applicatns submitted application form PopUp > Confirmation Message\n' +
	'\n' +
	'[FC-1199](https://flex-charge.atlassian.net/browse/FC-1199) User Invitation Email > Add text\n' +
	'\n' +
	'[FC-1198](https://flex-charge.atlassian.net/browse/FC-1198) Merchant portal > Fix typo\n' +
	'\n' +
	'[FC-1193](https://flex-charge.atlassian.net/browse/FC-1193) Merchant portal > Add color picker module\n' +
	'\n' +
	'[FC-1123](https://flex-charge.atlassian.net/browse/FC-1123) Portal > Implement Notification bar'+
	'\n' +
	'# Release notes - FlexCharge - Version MP\\_0.4.01\n' +
	'\n' +
	'### Bug\n' +
	'\n' +
	'[FC-1184](https://flex-charge.atlassian.net/browse/FC-1184) Payment page >  Change \'checkout iframe\' to \'checkout\'\n' +
	'\n' +
	'[FC-1183](https://flex-charge.atlassian.net/browse/FC-1183) Payment page >  Move checkbox to dev fields\n' +
	'\n' +
	'[FC-1175](https://flex-charge.atlassian.net/browse/FC-1175) Application page > Show status as Label instead of read-only input field\n' +
	'\n' +
	'[FC-1173](https://flex-charge.atlassian.net/browse/FC-1173) Payment page >  Set small prices for one items group\n' +
	'\n' +
	'[FC-1167](https://flex-charge.atlassian.net/browse/FC-1167) UI-WIdget > Add error messages for form group\n' +
	'\n' +
	'[FC-1163](https://flex-charge.atlassian.net/browse/FC-1163) Redirect to Login page does not work when user logout\n' +
	'\n' +
	'[FC-1162](https://flex-charge.atlassian.net/browse/FC-1162) Application page > After page reload or open edit mode, Fees checkbox is changed randomly\n' +
	'\n' +
	'[FC-1161](https://flex-charge.atlassian.net/browse/FC-1161) Applicant page > Data from Editor is shown as HTML code\n' +
	'\n' +
	'[FC-1155](https://flex-charge.atlassian.net/browse/FC-1155) Applicants > Multiselect > OK button align fix\n' +
	'\n' +
	'[FC-1154](https://flex-charge.atlassian.net/browse/FC-1154) Datepicker style optimization\n' +
	'\n' +
	'[FC-1151](https://flex-charge.atlassian.net/browse/FC-1151) Payment services > Capture return 404\n' +
	'\n' +
	'[FC-1148](https://flex-charge.atlassian.net/browse/FC-1148) Portal > Fix warnings, add local setup\n' +
	'\n' +
	'[FC-1146](https://flex-charge.atlassian.net/browse/FC-1146) Payment page >  Fix amount issue and test different cases for input or blocks\n' +
	'\n' +
	'[FC-1141](https://flex-charge.atlassian.net/browse/FC-1141) Payment page >  Add mid field\n' +
	'\n' +
	'[FC-1140](https://flex-charge.atlassian.net/browse/FC-1140) UI-WIdget > Fix challange error\n' +
	'\n' +
	'[FC-1138](https://flex-charge.atlassian.net/browse/FC-1138) Pagination > Show only 10 items\n' +
	'\n' +
	'[FC-1136](https://flex-charge.atlassian.net/browse/FC-1136) Payment page simulator > Unknown functionality\n' +
	'\n' +
	'[FC-1135](https://flex-charge.atlassian.net/browse/FC-1135) Payment page simulator > Error screen on checkout\n' +
	'\n' +
	'[FC-1134](https://flex-charge.atlassian.net/browse/FC-1134) Fees section on applicants > Not showing % fee value from API response\n' +
	'\n' +
	'[FC-1133](https://flex-charge.atlassian.net/browse/FC-1133) Github > Fees fix wasn\'t merged to dev and staging\n' +
	'\n' +
	'[FC-1126](https://flex-charge.atlassian.net/browse/FC-1126) UI-WIdget > Add logo\n' +
	'\n' +
	'[FC-1122](https://flex-charge.atlassian.net/browse/FC-1122) Payment page >  Responsive styles\n' +
	'\n' +
	'[FC-1120](https://flex-charge.atlassian.net/browse/FC-1120) Prepare widgets and servers to local launch\n' +
	'\n' +
	'[FC-1119](https://flex-charge.atlassian.net/browse/FC-1119) Payment page >  Clear basket for another user\n' +
	'\n' +
	'[FC-1117](https://flex-charge.atlassian.net/browse/FC-1117) Payment page >  Remove links to pages that don\'t work now\n' +
	'\n' +
	'[FC-1116](https://flex-charge.atlassian.net/browse/FC-1116) Payment page >  Change button text \'submit\' to \'checkout\'\n' +
	'\n' +
	'[FC-1112](https://flex-charge.atlassian.net/browse/FC-1112) Payment page >  Add proper error handler fro evaluate request\n' +
	'\n' +
	'[FC-1110](https://flex-charge.atlassian.net/browse/FC-1110) Payment page >  Remove script links after environment changes\n' +
	'\n' +
	'[FC-1109](https://flex-charge.atlassian.net/browse/FC-1109) Payment page >  Open developer fields when appKey, appSecret or spreedlyKey gets validation error\n' +
	'\n' +
	'[FC-1108](https://flex-charge.atlassian.net/browse/FC-1108) Payment page >  Fix text alignment in the basket\n' +
	'\n' +
	'[FC-1103](https://flex-charge.atlassian.net/browse/FC-1103) Payment page >  Fix widgets links when environment was changed\n' +
	'\n' +
	'[FC-1090](https://flex-charge.atlassian.net/browse/FC-1090) Application, Merchant view page > Adapt to mobile and tablet\n' +
	'\n' +
	'[FC-957](https://flex-charge.atlassian.net/browse/FC-957) Payments > Fix merchant activation error\n' +
	'\n' +
	'### Task\n' +
	'\n' +
	'[FC-1191](https://flex-charge.atlassian.net/browse/FC-1191) Application preview \\(Applicant user\\) > update terms sentence\n' +
	'\n' +
	'[FC-1172](https://flex-charge.atlassian.net/browse/FC-1172) Applications > Add row background color on modifiedOn today\n' +
	'\n' +
	'[FC-1170](https://flex-charge.atlassian.net/browse/FC-1170) Orders View > Administrator/Partner add MerchantName column\n' +
	'\n' +
	'[FC-1166](https://flex-charge.atlassian.net/browse/FC-1166) UI Widget - add configurable add/remove logo on the payment page simulator\n' +
	'\n' +
	'[FC-1160](https://flex-charge.atlassian.net/browse/FC-1160) Run full merchant onboarding QA cycle\n' +
	'\n' +
	'[FC-1157](https://flex-charge.atlassian.net/browse/FC-1157) UI Widget > Use validations passed in ChallengeResponse DTO\n' +
	'\n' +
	'[FC-1104](https://flex-charge.atlassian.net/browse/FC-1104) Developers section pages > Adapt to mobile and tablet\n' +
	'\n' +
	'[FC-1076](https://flex-charge.atlassian.net/browse/FC-1076) Merchants > Upload historical data functionality\n' +
	'\n' +
	'[FC-1075](https://flex-charge.atlassian.net/browse/FC-1075) Align design like on merchants > Orders & settlements top search/filter view\n' +
	'\n' +
	'[FC-1073](https://flex-charge.atlassian.net/browse/FC-1073) DNS update > change fc-portal-staging => portal-staging\n' +
	'\n' +
	'[FC-1071](https://flex-charge.atlassian.net/browse/FC-1071) Mobile View > Header fix > show only F icon instead of the logo\n' +
	'\n' +
	'[FC-1070](https://flex-charge.atlassian.net/browse/FC-1070) Home page menu > add mobile functionality menu\n' +
	'\n' +
	'[FC-1069](https://flex-charge.atlassian.net/browse/FC-1069) Login page mobile compatibility\n' +
	'\n' +
	'[FC-1053](https://flex-charge.atlassian.net/browse/FC-1053) Payment page >  Add options to choose checkout page \\(iframe, hosted fields etc\\)\n' +
	'\n' +
	'[FC-1026](https://flex-charge.atlassian.net/browse/FC-1026) Email notifications on Application SUBMITTED and Merchant ACTIVATED\n' +
	'\n' +
	'[FC-1017](https://flex-charge.atlassian.net/browse/FC-1017) Add new > End user agreement\n' +
	'\n' +
	'[FC-1004](https://flex-charge.atlassian.net/browse/FC-1004) UI-WIdget > Implement dropdown\n' +
	'\n' +
	'[FC-1001](https://flex-charge.atlassian.net/browse/FC-1001) UI-WIdget > Implement inputs in groups design\n' +
	'\n' +
	'[FC-995](https://flex-charge.atlassian.net/browse/FC-995) ApiClient - Remove keys expiration period \\(check if applicable\\)'+
	'\n' +
	'# Release notes - Version 0.3.63\n' +
	'\n' +
	'### Bug\n' +
	'\n' +
	'[FC-969](https://flex-charge.atlassian.net/browse/FC-969) New Application > Remove partner as a required field\n' +
	'\n' +
	'[FC-967](https://flex-charge.atlassian.net/browse/FC-967) New/Edit Application > Established date should be not required\n' +
	'\n' +
	'[FC-683](https://flex-charge.atlassian.net/browse/FC-683) Portal > GET Application > standardFeeSelected prop is missing\n' +
	'\n' +
	'### Task\n' +
	'\n' +
	'[FC-1066](https://flex-charge.atlassian.net/browse/FC-1066) Status Multiselect > Add OK button to close Multiselect and send request\n' +
	'\n' +
	'[FC-1048](https://flex-charge.atlassian.net/browse/FC-1048) Payment page simulator > New declined page\n' +
	'\n' +
	'[FC-1033](https://flex-charge.atlassian.net/browse/FC-1033) New application > states select fix\n' +
	'\n' +
	'[FC-1022](https://flex-charge.atlassian.net/browse/FC-1022) Applicants > Add decline application API\n' +
	'\n' +
	'[FC-1020](https://flex-charge.atlassian.net/browse/FC-1020) Improve basket design\n' +
	'\n' +
	'[FC-1015](https://flex-charge.atlassian.net/browse/FC-1015) Submitted Application > Disable Edit button\n' +
	'\n' +
	'[FC-1012](https://flex-charge.atlassian.net/browse/FC-1012) Dashboard amounts spacing between number and text\n' +
	'\n' +
	'[FC-1010](https://flex-charge.atlassian.net/browse/FC-1010) Cancelled application - Make view only\n' +
	'\n' +
	'[FC-1008](https://flex-charge.atlassian.net/browse/FC-1008) Merchant > Redesign Fees section\n' +
	'\n' +
	'[FC-1003](https://flex-charge.atlassian.net/browse/FC-1003) Merchant portal > Applicants > Add option to decline applicant\n' +
	'\n' +
	'[FC-996](https://flex-charge.atlassian.net/browse/FC-996) Confirm password submit button error\n' +
	'\n' +
	'[FC-989](https://flex-charge.atlassian.net/browse/FC-989) Redirect to 404 on non existing routes\n' +
	'\n' +
	'[FC-987](https://flex-charge.atlassian.net/browse/FC-987) Application new > Fees section update UI \\(texts\\)\n' +
	'\n' +
	'[FC-985](https://flex-charge.atlassian.net/browse/FC-985) New identity provider setup \\(Sandbox\\)\n' +
	'\n' +
	'[FC-980](https://flex-charge.atlassian.net/browse/FC-980) Applications list > Fix date submitted column wrong date\n' +
	'\n' +
	'[FC-977](https://flex-charge.atlassian.net/browse/FC-977) Releases page > Display HTML from Markdown\n' +
	'\n' +
	'[FC-976](https://flex-charge.atlassian.net/browse/FC-976) Add i18n support\n' +
	'\n' +
	'[FC-964](https://flex-charge.atlassian.net/browse/FC-964) Applications > Add filter with multi-select for status\n' +
	'\n' +
	'[FC-959](https://flex-charge.atlassian.net/browse/FC-959) 404 page issue > missing button for redirect back to dashboard'+
	'\n' +
	'# Release notes - Version 0.3.53\n' +
	'\n' +
	'### Task\n' +
	'\n' +
	'[FC-926](https://flex-charge.atlassian.net/browse/FC-926) Merchant portal > Merchant agreement > new page\n' +
	'\n' +
	'[FC-914](https://flex-charge.atlassian.net/browse/FC-914) Portal > Connect to Refund API\n' +
	'\n' +
	'[FC-900](https://flex-charge.atlassian.net/browse/FC-900) Dashboard > Redo flexcharge graphs \\(bottom part of dashboard\\)\n' +
	'\n' +
	'[FC-787](https://flex-charge.atlassian.net/browse/FC-787) Application > Change blue color of hover \\(text and background\\) elements in dropdowns';
